import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { formatApiError } from '../../context/AuthContext';

const API = (process.env.CRA_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL);

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0b0b0e]">
      <div className="w-full max-w-[440px] bg-white rounded-2xl p-8 shadow-2xl">
        <h1 className="text-[22px] font-extrabold text-[#1D1D1F] mb-2">Reset your password</h1>
        <p className="text-[14px] text-[#6E6E73] mb-6">
          Enter your account email and we'll send a reset link.
        </p>

        {submitted ? (
          <div className="rounded-lg bg-amber-50 border border-amber-200 px-4 py-3 text-[14px] text-[#7a5b0a]">
            If an account exists for that email, a reset link has been sent.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email"
              placeholder="you@example.com"
              className="w-full px-4 py-2.5 rounded-lg border border-[#E5E5E7] focus:border-[#c9a227] focus:ring-2 focus:ring-[#c9a227]/30 outline-none"
            />
            {error && <div className="text-red-600 text-[13px]">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit"
              className="w-full px-6 py-3 rounded-full text-[14px] font-bold uppercase tracking-[0.16em] text-[#0e0e10] disabled:opacity-60"
              style={{ background: 'linear-gradient(90deg,#e6c35a,#c9a227,#a8871a)' }}
            >
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <div className="mt-6 text-[13px]">
          <Link to="/academy/login" className="text-[#c9a227] hover:underline font-semibold">← Back to login</Link>
        </div>
      </div>
    </div>
  );
}
